// A placeholder for external services. Will probably make sense to extract these as we increase our area of integration

import {useContaCommand} from '@/commandbar/commandBar.service'
import {selectedOrg} from '@/tenants/org.service'

export const salaryUrl = window.location.protocol + '//lonn.' + window.location.hostname.split('.').slice(1).join('.')
export const finstaUrl = window.location.protocol + '//arsoppgjor.' + window.location.hostname.split('.').slice(1).join('.')

const {registerCommand} = useContaCommand()

registerCommand({
    type: 'external-service',
    typeLabel: 'Ekstern',
    label: 'Brønnøysundregistrene',
    key: 'brreg',
    keywords: ['brreg', 'brønnøysund', 'registrene', 'firmaopplysninger', 'breg'],
    imageSrc: '/brreg_logo.svg',
    activate: () => {
        window.open('https://www.brreg.no/', '_blank')
    },
    isActive: () => true,
    showPanelSelector: false
})

registerCommand({
    type: 'external-service',
    typeLabel: 'Ekstern',
    label: 'Altinn',
    key: 'altinn',
    keywords: ['altinn', 'skatt', 'rapportering', 'a-melding'],
    imageSrc: '/altinn_logo.svg',
    activate: () => {
        window.open('https://www.altinn.no/', '_blank')
    },
    isActive: () => true,
    showPanelSelector: false
})

registerCommand({
    type: 'external-service',
    typeLabel: 'Ekstern',
    label: 'Skatteetaten',
    key: 'skatteetaten',
    keywords: ['skatteetaten', 'skatt', 'mva', 'skattemelding'],
    imageSrc: '/skatteetaten_logo.svg',
    activate: () => {
        window.open('https://www.skatteetaten.no/', '_blank')
    },
    isActive: () => true,
    showPanelSelector: false
})

registerCommand({
    type: 'external-service',
    typeLabel: 'Ekstern',
    label: 'Proff.no',
    key: 'proff',
    keywords: ['proff', 'firmaopplysninger', 'regnskap', 'økonomi'],
    imageSrc: '/proff_logo.svg',
    activate: () => {
        window.open('https://www.proff.no/', '_blank')
    },
    isActive: () => true,
    showPanelSelector: false
})

registerCommand({
    type: 'external-service',
    typeLabel: 'Ekstern',
    label: 'Lønn',
    key: 'conta-salary',
    keywords: ['lonn', 'lønn', 'salary', 'payroll', 'conta lønn', 'conta'],
    imageSrc: '/c-logo.svg',
    activate: () => {
        //TODO: Check with patron if active? Or let the target handle
        window.open(`${salaryUrl}/organization/${selectedOrg.value?.id}`, '_blank')
    },
    isActive: () => true,
    showPanelSelector: false
})

registerCommand({
    type: 'external-service',
    typeLabel: 'Ekstern',
    label: 'Årsoppgjør',
    key: 'conta-finsta',
    keywords: ['årsoppgjør', 'finsta', 'annual report', 'conta årsoppgjør', 'conta'],
    imageSrc: '/c-logo.svg',
    activate: () => {
        window.open(`${finstaUrl}/organization/${selectedOrg.value?.id}`, '_blank')
    },
    isActive: () => true,
    showPanelSelector: false
})